// ReviewsTable.js
import React, { useState, useEffect } from "react";

// Component for rendering the reviews table
const ReviewsTable = ({ reviews }) => {
    return (
        <table className="table">
            <thead>
                <tr>
                    <th scope="col">
                        <div className="form-check">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                value=""
                            />
                        </div>
                    </th>
                    <th scope="col">#</th>
                    <th scope="col">Product</th>
                    <th scope="col">Name</th>
                    <th scope="col">Rating</th>
                    <th scope="col">Date</th>
                    <th scope="col" className="text-end">
                        Action
                    </th>
                </tr>
            </thead>
            <tbody>
                {reviews.map((review) => (
                    <tr key={review.id}>
                        <td>
                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value=""
                                />
                            </div>
                        </td>
                        <td>{review.id}</td>
                        <td>
                            <b>{review.product}</b>
                        </td>
                        <td>{review.name}</td>
                        <td>
                            <ul className="rating-stars">
                                <li
                                    style={{ width: `${review.rating * 20}%` }}
                                    className="stars-active">
                                    <img
                                        src="assets/imgs/icons/stars-active.svg"
                                        alt="stars"
                                    />
                                </li>
                                <li>
                                    <img
                                        src="assets/imgs/icons/starts-disable.svg"
                                        alt="stars"
                                    />
                                </li>
                            </ul>
                        </td>
                        <td>{review.date}</td>
                        <td className="text-end">
                            <div className="dropdown">
                                <a
                                    href="#"
                                    data-bs-toggle="dropdown"
                                    className="btn btn-light rounded btn-sm font-sm">
                                    <i className="material-icons md-more_horiz"></i>
                                </a>
                                <div className="dropdown-menu">
                                    <a className="dropdown-item" href="#">
                                        View detail
                                    </a>
                                    <a className="dropdown-item" href="#">
                                        Edit info
                                    </a>
                                    <a
                                        className="dropdown-item text-danger"
                                        href="#">
                                        Delete
                                    </a>
                                </div>
                            </div>
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

const App = () => {
    const [reviews, setReviews] = useState([]);
    const [search, setSearch] = useState("");

    useEffect(() => {
        // Mock fetch function
        const fetchReviews = async () => {
            const mockData = [
                {
                    id: 1,
                    product: "Product A",
                    name: "John Doe",
                    rating: 4,
                    date: "2024-12-01",
                },
                {
                    id: 2,
                    product: "Product B",
                    name: "Jane Smith",
                    rating: 5,
                    date: "2024-12-02",
                },
            ];
            setReviews(mockData);
        };
        fetchReviews();
    }, []);

    // Filter reviews based on search query
    const filteredReviews = reviews.filter((review) =>
        review.name.toLowerCase().includes(search.toLowerCase())
    );

    return (
        <div className="container">
            <h1>Reviews</h1>
            <div className="mb-3">
                <input
                    type="text"
                    placeholder="Search by name"
                    className="form-control bg-white"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                />
            </div>
            <ReviewsTable reviews={filteredReviews} />
        </div>
    );
};

export default App;
